


































































































































































































import { plainToInstance } from 'class-transformer'
import isMobile from 'piramis-js-utils/lib/isMobile'
import { Component, Mixins, Prop } from 'vue-property-decorator'

import ModelSetter from "../../../../../../../../../Mixins/ModelSetter";
import { errorNotificationWrapper, warningNotificationWrapper } from '../../../../../../../../../logic/helpers/NotificationService'
import { ErrorChannelInfo, SuccessChannelInfo } from '../../../../../../../../../models/CheckChannels/CheckChannels'
import { atSignedLogin } from '../../../../../../../../../shared/utils/tgLoginHelpers'
import ConfigField from '../../../../../../../../ConfigField/ConfigField.vue'
import MiniHelpMessage from '../../../../../../../../MiniHelpMessage/MiniHelpMessage.vue'
import { UseFields } from '../../../../../../../../Pi'
import NewMultiMessageEditorWithMediaInput
  from '../../../../../../../../Pi/fields/NewMultiMessageEditorWithMediaInput/MultiMessageEditorWithMediaInput.vue'
import SelectOption from '../../../../../../../../Pi/fields/SelectInput/components/SelectOption.vue'
import { FieldData, SelectOptionData } from '../../../../../../../../Pi/types'
import TargetCard from "../../../../../../../../TargetCard/TargetCard.vue";
import { TargetCardInfo } from "../../../../../../../../TargetCard/types";
import CustomEditor from '../../../../../Editor/CustomEditor'
import ChannelsInfoHelper from '../../../../../Helpers/ChannelsInfoHelper'
import UsersInfoHelper from '../../../../../Helpers/UserInfoHelper'
import { ForwardMessageNode } from '../../logic/ForwardMessageNode'
import { SendMessageMode } from '../../logic/types'

@Component({
  data() {
    return {
      isMobile,
    }
  },
  components: {
    TargetCard,
    NewMultiMessageEditorWithMediaInput,
    MiniHelpMessage,
    SelectOption,
    ConfigField
  }
})
export default class ForwardMessageSidebar extends Mixins(UseFields, ModelSetter) {
  @Prop() node!: ForwardMessageNode

  @Prop() editor!: CustomEditor

  targetId = ''

  get filteredTargets() {
    return this.node.nodeProps.targets.filter(t => !this.node.data.targets.includes(t.value))
  }

  get filteredAdmins() {
    return this.node.nodeProps.admins.filter(t => !this.node.data.targets.includes(t.value))
  }

  get modeOptions(): Array<SelectOptionData> {
    return Object.values(SendMessageMode)
      .map(v => ({
        label: this.$t(`forward_message_mode_${ v.toLowerCase() }_option`).toString(),
        value: v
      }))
  }

  get beautifiedTargets(): Array<TargetCardInfo> {
    // eslint-disable-next-line sonarjs/cognitive-complexity
    return this.node.data.targets.map(id => {
      if (id < 0) {
        const target = ChannelsInfoHelper.GetChannel(id.toString())

        const isSuccessChannelInfo = target instanceof SuccessChannelInfo

        return {
          type: isSuccessChannelInfo ? target?.info?.type?.toLowerCase()?.toString() : null,
          id: isSuccessChannelInfo ? target?.info?.id : target!.value,
          title: isSuccessChannelInfo ? target?.info?.title : null,
          login: isSuccessChannelInfo ? (target?.info?.login ?? null) : null,
          error: target instanceof ErrorChannelInfo ? target.error : null,
        }
      } else {
        const user = UsersInfoHelper.getUser(id)
        const formattedLogin = user?.info?.login ? `(${ atSignedLogin(user?.info?.login) })` : ''

        return {
          type: user?.info?.type?.toLowerCase() ?? null,
          id: user?.info?.id ?? user!.value,
          title: user?.info ? `${ user?.info?.name } ${ formattedLogin }` : null,
          error: user?.error ? user.error : null,
        }

      }
    })
  }

  userExistsNotify() {
    warningNotificationWrapper(this.$t('notification_warn_user_exists').toString(), '')
  }

  channelGroupExistsNotify() {
    warningNotificationWrapper(this.$t('notification_warn_target_exists').toString(), '')
  }

  addChannelOrGroup(targetId: number) {
    if (!this.node.hasTarget(targetId)) {
      const existedTargets = this.node.nodeProps.targets
      const target = existedTargets.find(target => target.value === targetId)

      if (target) {
        ChannelsInfoHelper.Channels.push(plainToInstance(SuccessChannelInfo, {
          status: true,
          info: {
            id: target.value,
            title: target.label,
            type: 'CHANNEL',
          }
        }))

        this.node.data.targets.push(target.value)

        this.targetId = ''
      } else {
        this.editor.getChannelsInfo([ targetId ])
          .then((res) => {
            const info = res.data[0]

            if (info instanceof ErrorChannelInfo) {
              errorNotificationWrapper(this.$t('error').toString(), info.error)
            }
            if (info instanceof SuccessChannelInfo) {
              this.node.data.targets.push(info.info.id)
              this.targetId = ''
            }
          })
      }
    } else {
      this.channelGroupExistsNotify()
    }
  }

  addUser(userData: string) {
    this.editor.getUsersInfo([ userData ])
      .then((res) => {
        if (res.data.length) {
          const user = res.data[0]
          if (!this.node.hasTarget(user?.info?.id)) {
            this.node.data.targets.push(user.info.id)
          } else {
            this.userExistsNotify()
          }
        } else {
          errorNotificationWrapper(this.$t('error').toString(), this.$t('notification_warn_user_not_found').toString())
        }

        this.targetId = ''
      })
  }

  addTarget(target?: string) {
    // eslint-disable-next-line sonarjs/no-identical-expressions
    const isNumber = (value: any) => typeof value === 'number' || +value - +value === 0
    const trimmedTargetValue = target?.trim() ?? this.targetId.trim()

    if (trimmedTargetValue) {
      if (isNumber(trimmedTargetValue)) {
        const parsed = Number.parseInt(trimmedTargetValue)

        if (parsed < 0) { // channel/group
          this.addChannelOrGroup(parsed)
        } else { //user
          if (!this.node.hasTarget(parsed)) {
            this.addUser(trimmedTargetValue)
          } else {
            this.userExistsNotify()
          }
        }
      } else {
        this.addUser(trimmedTargetValue)
      }
    }
  }

  setFailTryMaxCount(arg: FieldData): FieldData {
    arg.setter = (val) => this.node.setFailTryMaxCount(val)
    return arg
  }

  setTargets(arg: FieldData): FieldData {
    arg.setter = (val) => this.node.setTargets(val)
    return arg
  }

  setFailMessage(arg: FieldData): FieldData {
    arg.setter = (val) => this.node.setFailMessage(val)
    return arg
  }

  setRegexObj(arg: FieldData): FieldData {
    arg.setter = (val) => this.node.toggleRegex(val, this)
    return arg
  }

  setMinLength(arg: FieldData): FieldData {
    arg.setter = (val) => this.node.setMinLength(val)
    return arg
  }

  setMaxLength(arg: FieldData): FieldData {
    arg.setter = (val) => this.node.setMaxLength(val)
    return arg
  }

  setPattern(arg: FieldData): FieldData {
    arg.setter = (val) => this.node.setPattern(val)
    return arg
  }

  setInvert(arg: FieldData): FieldData {
    arg.setter = (val) => this.node.setInvert(val)
    return arg
  }

  setMode(arg: FieldData): FieldData {
    arg.setter = (val) => this.node.setMode(val)
    return arg
  }

  selectOption(value: string) {
    this.addTarget(value)
  }
}
